export default "__VITE_ASSET__B3mIz1Db__"